// assets/brand-marquee.js
(function () {
  function initMarquee(root) {
    const viewport = root.querySelector('.brand-viewport');
    const track = root.querySelector('.brand-track');
    if (!viewport || !track) return;

    // Clone content once for seamless loop
    if (!track.dataset.cloned) {
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    }

    let speed = parseFloat(root.dataset.speed || '0.4'); // px per frame
    let running = true;
    let raf;

    function tick() {
      if (running) {
        viewport.scrollLeft += speed;
        // Reset when half reached (because we doubled the content)
        if (viewport.scrollLeft >= track.scrollWidth / 2) {
          viewport.scrollLeft = 0;
        }
      }
      raf = requestAnimationFrame(tick);
    }

    // Start
    raf = requestAnimationFrame(tick);

    // Pause on hover / touch
    root.addEventListener('mouseenter', () => (running = false));
    root.addEventListener('mouseleave', () => (running = true));
    root.addEventListener('touchstart', () => (running = false), { passive: true });
    root.addEventListener('touchend', () => (running = true), { passive: true });

    // Drag / swipe support
    let isDown = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
      track.setPointerCapture(e.pointerId);
      running = false;
    });
    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      viewport.scrollLeft = startLeft - (e.clientX - startX);
    });
    function end() { isDown = false; running = true; }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.brand-marquee').forEach(initMarquee);
  });
})();
